import "./footerphone.css";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import facebookIcon from "@/assets/facebook.png";
import instagramIcon from "@/assets/instagram.png";
import whatsappIcon from "@/assets/whatsapp.png";
import anpcSalSvg from "@/components/common/footer/anpc-sal.svg";
import anpcSolSvg from "@/components/common/footer/anpc-sol.svg";
import gdprEuSvg from "@/components/common/footer/gdpr.eu.svg";

interface FooterProps {
  logo: string;
  greenDot: string;
  NextButton: React.FC<any>;
  handleScrollToTop: () => void;
}

const FooterPhone: React.FC<FooterProps> = ({
  logo,
  greenDot,
  NextButton,
  handleScrollToTop,
}) => {
  return (
    <Container className="phone-footer-container">
      <div className="phone-footer-base">
        {/* Background image - for sizing */}
        <img
          className="phone-footer-base-img"
          src="/footer/footer-base-phone.webp"
          style={{ visibility: 'hidden' }}
          alt=""
        />
        
        {/* Green dots decoration */}
        <div className="phone-green-dots">
          <img className="phone-green-dot" src={greenDot} alt="" />
          <img className="phone-green-dot" src={greenDot} alt="" />
          <img className="phone-green-dot" src={greenDot} alt="" />
        </div>
        
        {/* Scroll to top button */}
        <NextButton
          onClick={handleScrollToTop}
          className="phone-footer-next"
        />
        
        {/* EVERYTHING IN ONE CONTAINER - NATURAL FLOW */}
        <div className="phone-footer-top-section">
          {/* Logo */}
          <div className="phone-logo-row">
            <img className="phone-logo-footer" src={logo} alt="Pixado Logo" />
          </div>
          
          {/* Text */}
          <p className="phone-footer-text body">
            Pixado este agenția ta de încredere pentru soluții creative de branding, web design & development, online marketing, reclame video și CGI/VFX. Cu un ochi atent pentru detalii și o echipă pasionată, transformăm ideile în realitate, livrând mereu rezultate memorabile.
          </p>

          {/* FOOTER LINKS SECTION */}
          <div className="phone-footer-links-section">
            {/* FIRST ROW - Linkuri Rapide + Contact SIDE BY SIDE */}
            <div className="phone-footer-first-row">
              <div className="phone-footer-col phone-links-rapide">
                <div className="phone-footer-title title-4">Linkuri Rapide</div>
                <div className="phone-footer-option">
                  <Link to="/servicii/web-design" className="phone-back-link">Web Design</Link>
                </div>
                <div className="phone-footer-option">
                  <Link to="/servicii/e-commerce" className="phone-back-link">E-commerce</Link>
                </div>
                <div className="phone-footer-option">
                  <Link to="/servicii/branding" className="phone-back-link">Branding</Link>
                </div>
                <div className="phone-footer-option">
                  <Link to="/servicii/online-marketing" className="phone-back-link">Online Marketing</Link>
                </div>
              </div>
              
              <div className="phone-footer-col phone-contact">
                <div className="phone-footer-title title-4">Contact</div>
                <div className="phone-contact-info">Timișoara</div>
                <div className="phone-contact-info">0745371620</div>
                <div className="phone-contact-info">contact@pixado.ro</div>
              </div>
            </div>
            
            {/* SECOND ROW - Linkuri Utile + Social Media SIDE BY SIDE */}
            <div className="phone-footer-second-row">
              <div className="phone-footer-col phone-links-utile">
                <div className="phone-footer-title title-4">Linkuri Utile</div>
                <div className="phone-footer-svg-container">
                  <div className="phone-footer-svg-item">
                   <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer">                      
                     <img src={anpcSalSvg} alt="ANPC SAL" className="phone-footer-svg" />
                    </a>
                  </div>
                  <div className="phone-footer-svg-item">
                    <a href="https://consumer-redress.ec.europa.eu/index_ro" target="_blank" rel="noopener noreferrer">
                      <img src={anpcSolSvg} alt="ANPC SOL" className="phone-footer-svg" />
                    </a>
                  </div>
                  <div className="phone-footer-svg-item">
                    <a href="https://gdpr.eu/" target="_blank" rel="noopener noreferrer">
                      <img src={gdprEuSvg} alt="GDPR EU" className="phone-footer-svg" />
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="phone-footer-social-section">
                <div className="phone-footer-social-text body">Hai cu noi pe social media!</div>
                <div className="phone-footer-social-icons-container">
                  <a href="https://www.facebook.com/pixadoagency" target="_blank" rel="noopener noreferrer">
                    <img src={facebookIcon} className="phone-contact-dot" alt="Facebook" />
                  </a>
                  <a href="https://www.instagram.com/pixadoagency/" target="_blank" rel="noopener noreferrer">
                    <img src={instagramIcon} className="phone-contact-dot" alt="Instagram" />
                  </a>
                  <a href="https://wa.me/40745371620" target="_blank" rel="noopener noreferrer">
                    <img src={whatsappIcon} className="phone-contact-dot" alt="WhatsApp" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Center Text - SAME AS DESKTOP/TABLET */}
          <div className="phone-footer-row-center title-1">
            AICI PENTRU TINE
          </div>
          
          {/* Bottom Legal Links - 2 COLUMNS LIKE TABLET */}
          <div className="phone-footer-row-bottom body">
            <div className="phone-bottom-row-options-1">
              <div>website aflat in construcție</div>
              <div>© 2026 pixado agency</div>
            </div>
            <div className="phone-bottom-row-options-2">
              <div className="phone-footer-option">
                <Link to="/politica-confidentialitate" className="phone-back-link" onClick={handleScrollToTop}>
                  Politica de confidențialitate
                </Link>
                </div>
                <div className="phone-footer-option">
                  <Link to="/termeni-conditii" className="phone-back-link" onClick={handleScrollToTop}>
                    Termeni și condiții
                  </Link>
                </div>
                <div className="phone-footer-option">
                  <Link to="/politica-cookies" className="phone-back-link" onClick={handleScrollToTop}>
                    Politica de Cookies
                  </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FooterPhone;